module.exports = __webpack_public_path__ + "img/Premium TimerFail.e16aaaed.png";